mutation RequestMultipleMaterialUploadUrls($input: RequestMultipleMaterialUploadUrlsInput!) {
  requestMultipleMaterialUploadUrls(input: $input) {
    uploadUrl
    s3Key
    expiresAt
  }
}
